module.exports = __webpack_public_path__ + "static/media/1876.81cc3de9.jpg";